import * as ng from 'angular';

export const FocusMe = () => (<angular.IDirective>{

    link: (scope: ng.IScope, element: JQLite, attrs: any) => {
        scope.$watch(attrs.focusMe, (value) => {
            if (value === true) {
                element[0].focus();
            }
        });
    }
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/focus-me/focus-me.directive.ts